<div *ngIf="old"class=flex>
  <p *ngIf="old">We noticed that you're using a browser thats a bit old.
      This website has been tested on most modern browsers.<br> 
      Upgrade your browser to the latest to avoid known issues.
      <span *ngIf="notChrome"><br>Consider using Chrome for the best experience.</span> 
    </p>

</div>